import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router";
import axios from "axios";
import { base_url } from "../../Constant";
import "./VerifyMember.css";
import "../../../index.css";
import "../../../App.css";

const VerifyMember = () => {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMemberStatus();
  }, [id]);

  const fetchMemberStatus = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${base_url}/admin/get-member-status/${id}`
      );

      if (response.data.success && response.data.member) {
        setMember(response.data.member);
        setError(null);
      } else {
        setError("Member not found or invalid ID");
        setMember(null);
      }
    } catch (err) {
      console.error("Error fetching member:", err);
      setError(err.response?.data?.message || "Failed to fetch member details");
      setMember(null);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusClass = {
      active: "success",
      inactive: "secondary",
      pending: "warning",
      rejected: "danger",
    }[status?.toLowerCase()] || "info";

    return <span className={`badge bg-${statusClass}`}>{status}</span>;
  };

  return (
    <>
    <div className="verify-member-container">
      <div className="verify-member-wrapper">
        <div className="verify-member-header">
          <h1>Member Verification</h1>
          <p>Verify member details and status</p>
        </div>

        {loading && (
          <div className="loading-spinner">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>Loading member details...</p>
          </div>
        )}

        {error && !loading && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>Error!</strong> {error}
            <button
              type="button"
              className="btn-close"
              onClick={() => setError(null)}
            ></button>
          </div>
        )}

        {member && !loading && (
          <div className="member-details-card">
            {/* Member Photo */}
            <div className="member-photo-section">
              {member.photo && (
                <div className="photo-container">
                  <img
                    src={`data:image/jpeg;base64,${member.photo}`}
                    alt={member.name}
                    className="member-photo"
                  />
                </div>
              )}
            </div>

            {/* Member Information */}
            <div className="member-info-section">
              <div className="info-row header-row">
                <div className="info-field">
                  <label>Name</label>
                  <h2 className="member-name">{member.name}</h2>
                </div>
                <div className="info-field status-field">
                  <label>Status</label>
                  <div className="status-badge">
                    {getStatusBadge(member.status)}
                  </div>
                </div>
              </div>

              <div className="info-grid">
                <div className="info-field">
                  <label>Gender</label>
                  <p className="info-value">
                    {member.gender?.charAt(0).toUpperCase() +
                      member.gender?.slice(1)}
                  </p>
                </div>

                <div className="info-field">
                  <label>Blood Group</label>
                  <p className="info-value blood-group">{member.bloodGroup}</p>
                </div>

                <div className="info-field full-width">
                  <label>Mobile Number</label>
                  <p className="info-value mobile-number">
                    <a href={`tel:${member.mobile}`}>{member.mobile}</a>
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="action-buttons">
                <button
                  className="btn btn-primary"
                  onClick={() => window.print()}
                >
                  <i className="bi bi-printer"></i> Print Details
                </button>
              </div>
            </div>
          </div>
        )}

        {!loading && !error && !member && (
          <div className="no-data-message">
            <p>No member data available</p>
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default VerifyMember;
